import { ExpertAnketaAnswerText } from './ExpertAnketaAnswerText';

export default ExpertAnketaAnswerText;

